import { Injectable } from '@angular/core'

import { Observable } from 'rxjs/Observable'

import { LectureApiBase } from '../lecture-api'
import { PlayHistory, User } from '../../models'

export interface IHistoryStat {
  users: User[]
  seek: { [userId: number]: any }
  jump: { [userId: number]: any }
  skip: { [userId: number]: any }
  rate: { [userId: number]: any }
}

@Injectable()
export abstract class PlayHistoryApi {
  abstract apiPath(resourceId: number, historyId?)

  constructor(
    private api: LectureApiBase,
  ) { }

  index(resourceId: number): Observable<PlayHistory[]> {
    return this.api.listWithObject(PlayHistory, this.apiPath(resourceId))
  }

  stat(resourceId: number, groupIds?: number[]): Observable<IHistoryStat> {
    return this.api.get(this.api.makeUrlWithParams(this.apiPath(resourceId, 'stat'), {groupIds}))
  }

  post(resourceId: number, kind: string): Observable<PlayHistory> {
    return this.api.postWithObject(PlayHistory, this.apiPath(resourceId),
      {
        play_history: { kind }
      }
    )
  }

  batchPost(resourceId: number, histories: PlayHistory[]): Observable<any> {
    return this.api.post(this.apiPath(resourceId, 'batch_create'),
      {
        play_histories: histories
      }
    )
  }

  delete(resourceId: number, historyId: number): Observable<any> {
    return this.api.delete(this.apiPath(resourceId, historyId.toString()))
  }
}



// WEBPACK FOOTER //
// ./src/apis/play-history/base.ts